export const globalNav = {
    billing: {
        id: `tfb_billing`,
        viewUsageDetails: {
            routes: ['usage-details']
        },
        viewUsageCharges: {
            routes: ['usage-charges']
        },
    },
    payment: {
        id: `tfb_payment`,
        makePayment: {
            routes: ['payment','makepayment']
        },
        autoPayment: {
            routes: ['payment', 'autopayment']
        }
    },
    upgrade: {
        id: `tfb_upgrade`,
        selectLines : {
            routes: ['upgrade','select-lines']
        }
    },
    transaction: {
        id: `tfb_transaction_history`,
        selectLines : {
            routes: ['order-details']
        }
    }

};
  